import { render, staticRenderFns } from "./allowupgrade.vue?vue&type=template&id=4a06aa4d&"
import script from "./allowupgrade.vue?vue&type=script&lang=ts&"
export * from "./allowupgrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports